export const baseConfigClient = {
	grid: {
		imagesPerRow: 5,
		imageAspectRatio: '3/4',
        nameStyle: 'first-and-initial', //first-and-last ||first||first-and-initial (default) ||first-and-initial-and-dot
        showFeatures: true
    },
    model: {
        nameStyle: 'first-and-initial', //first-and-last ||first||first-and-initial (default) ||first-and-initial-and-dot
        showBirthDate: false,
        showAge: false,
        customFields: []
    },
    playlistViewer: {
        style: 'classic', //classic (default) || vscroll
        imageRatio: '130%', //default to 125% - only for vscroll style - it's the ratio of the image height to the width
        imageGutter: '.5rem', //default to .5rem - only for vscroll style
        showPublicDescription: true //default to true
    },
    packageInfo: {
        show: true, //true (default)||false to show or hide the package info on the right top of the page and in the models drawer
        //custom html content shown right below the package info (empty or null to hide it)
        //"<a href=\"https://www.mysite.com\" target=\"_blank\"><img src=\"https://mycdn.com/tenantassets/my_banner.png\" style=\"height:60px; width:auto;\" alt=\"my_banner\" /></a>"
        extra: "",
        //true to show the extra content also in the models drawer/sider, false (default) to show it only in the header
        showExtraInDrawer: false,
    },
    packageIndex: {
        //true (default) to show the playlists (with cover) of the selected model in the package index (models drawer/sider), false to show only the model row
        showModelPlaylists: true,
        //true to show the features of each model (as configured in "features") under its name in the package index, false (default) to hide them
        showFeatures: false,
        //true to show birthdate/age (only if enabled in "model") and custom fields of each model under its name in the package index, false (default) to hide them
        showAdditionalInfo: false,
    },
	features: {
		showOnList: true,
        //metric items should contain gender (0 or no property at all for all), conversionName and metrics (array of strings with "{metric name}:{metric suffix}")
        metrics: [
			{
				//gender: 0,
                conversionName: 'centimeters and inches',
				metrics: ['cm:cm'] // 'in:in'
			},
            {
				//gender: 0,
                conversionName: 'centimeters and feet',
				metrics: ['cm:cm'] // 'in:in'
			},
			{
				gender: 1,
                conversionName: 'shoes*',
				metrics: ['EU:eu'] // 'USW:us'
			},
            {
				gender: 2,
                conversionName: 'shoes*',
				metrics: ['EU:eu'] // 'USM:us'
			},
            {
				gender: 1,
                conversionName: 'dress size*',
				metrics: ['IT'] // 'FR', 'UK', 'US', 'JP'
			},
            {
				gender: 1,
                conversionName: 'pants size*',
				metrics: ['EU'] // 'US'
			},
            {
				gender: 2,
                conversionName: 'suit size*',
				metrics: ['EU'] // 'UK', 'US', 'JP'
			},
		],
        //use selectedFeatures if you want to show only some features of all the published features
        //should be a list of "displayName"
        selectedFeatures: []
	},
	themeType: 'light',
    //if url is null it will take {containerUrl}/tenantassets/logo.png
    //if url has no http it will take {containerUrl}/tenantassets/{url}
    //if url has http it will take {url}
    //if url is not valid it will show the tenant name
	logo: {
		url: null,
		maxWidth: "15rem", //default to 15 x 5rem
        maxWidthMobile: "12rem",//default to 12 x 4rem
        maxHeight: "8rem",
        maxHeightMobile: "6rem",
        link: null //link to open when clicking the logo (sometime the website homepage)
    },
    header: {
        htmlContent: ""
        //"<strong>Model Management</strong><br/>test header<br/>another line"
    },
    footer : {
        htmlContent: ""
        //"<strong>Model Management</strong> - test footer"
    },
	socials: {
        //to hide all socials, otherwise can be configured individually (showByType)
        hideAll: false,
        //show by default: 'instagram','imdb','modelscom','tiktok'
        //other: 'facebook','twitter','youtube','vimeo','modelscom','tiktok'
        showByType: ['instagram', 'modelscom','imdb','tiktok']
    },
    playlistTemplates: [
        {
          type: "Portfolio",
          name: "Portfolio",
		  isCustom: false,
          file: "standard.cshtml",
          orientation: "Landscape"
        }
    ],
    compcardTemplates: [
        {
            type: "Compcard",
            name: "Compcard",
            isCustom: false,
            isDefault: true,
            file: "compcard.cshtml",
            orientation: "Landscape"
        }
    ],
    exportOptions: {
        zipDownload: true,
        pdfPlaylist: true,
        pdfCompcard: true
    },
    departmentsOverrides: []
};
